import { Message } from "element-ui";
import AgentRegistration from '~/api/agent_registration';
import PasswordSettings from '~/api/password_settings';

export default {
    async checkEmailAddress({}, payload) {
        try {
            return await AgentRegistration.checkEmailAddress({
                emailAddress: payload
            });
        } catch(error) {
            Message({
                type: 'error',
                message: 'Error: Your email address is invalid.  Please double check that you\'ve entered it correctly.'
            })
        }
    },

    async createNewAccount({ commit, state }) {
        commit('updateLoading', { createNewAccount: true });

        try {
            const data = await AgentRegistration.createNewAccount(state.formData);

            commit('updateFormData', {
                userId: data.user_id
            });

            commit('updateFormShowingStatus', {
                formName: 'accountForm',
                showingStatus: false
            });

            commit('updateFormShowingStatus', {
                formName: 'profileSettingsForm',
                showingStatus: true
            });

            return data;
        } catch (error) {
            Message({
                type: 'error',
                message: error
            });
        } finally {
            commit('updateLoading', { createNewAccount: false });
        }
    },

    async updateUserAccount({ commit, state }) {
        commit('updateLoading', { updateAccount: true });

        try {
            return await AgentRegistration.updateUserAccount(state.formData);
        } catch (error) {
            Message({
                message: 'Unable to update account',
                type: 'error'
            });
        } finally {
            commit('updateLoading', { updateAccount: false });
        }
    },

    async getFormData({ commit }) {
        commit('updateLoading', { getFormData: true });

        try {
            const data = await AgentRegistration.getFormData();

            commit('saveLists', {
                mlsList: data.mls_list,
                stateList: data.state_list,
                timeZoneList: data.timezones
            });

            return data;
        } catch (error) {
            Message({
                message: 'Unable to retrieve required data',
                type: 'error'
            });
        } finally {
            commit('updateLoading', { formData: false });
        }
    },

    async saveUserImage({ commit, state }, payload) {
        commit('updateLoading', { saveUserImage: true });

        try {
            return await AgentRegistration.saveUserImage({
                user_id: state.formData.userId,
                type: payload.type,
                file: state.formData[payload.field]
            });
        } catch (error) {
            throw new Error(error);
        } finally {
            commit('updateLoading', { saveUserImage: false });
        }
    },

    async getPasswordRules({ commit }) {
        try {
            const data = await PasswordSettings.getPasswordRules("");

            commit('savePasswordRules', {
                rules: data.rules
            });

            return data;
        } catch (error) {
            Message({
                message: 'Something went wrong, while retrieving the password rules',
                type: 'error'
            });
        }
    }
};
